import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the styles array
 * @param {string[]} styles - Array of style strings
 */
export const setStyles = (styles) => {
  searchPageStore.setState({ styles })
}

/**
 * Adds a style to the array
 * @param {string} style - Style to add
 */
export const addStyle = (style) => {
  const state = searchPageStore.getState()
  const currentStyles = state.styles || []

  if (!currentStyles.includes(style)) {
    searchPageStore.setState({ styles: [...currentStyles, style] })
  }
}

/**
 * Removes a style from the array
 * @param {string} style - Style to remove
 */
export const removeStyle = (style) => {
  const state = searchPageStore.getState()
  const currentStyles = state.styles || []

  searchPageStore.setState({
    styles: currentStyles.filter((s) => s !== style),
  })
}

/**
 * Clears all styles
 */
export const clearStyles = () => {
  searchPageStore.setState({
    styles: DEFAULT_STATE.styles,
  })
}
